import { Button, Tooltip, GlanceLoader } from '../ui-components';
import React from 'react';

function InitialState({onEnterKey, onMCS, gicon, languageManager}) {

  return (
    <>
      <div className="SizeWrapper">
        <div className="rowAlign">
          { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
          <span className="wrapper" id="EnterKeyWrapper" data-testid="EnterKeyWrapper">
          <Tooltip text={languageManager.getPhrase("integration-customer-key-request","Customer’s key request")} offset={8} size="small">
            <Button
              size="small"
              variant="primary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onEnterKey) === typeof(Function)) ? onEnterKey() : console.log('EK pressed')}
            >
              {languageManager.getPhrase("integration-enter-key","Enter key")}
            </Button>
            </Tooltip>
          </span>

          <span className="wrapper" id="CameraShareWrapper" data-testid="CameraShareWrapper">
            <Tooltip text={languageManager.getPhrase("integration-send-link-to-phone","Send link to customer’s phone")} offset={8} size="small"> 
            <Button
              size="small"
              variant="tertiary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onMCS) === typeof(Function)) ? onMCS() : console.log('MCS pressed')}
            >
              {languageManager.getPhrase("integration-camera-share","Camera Share")}
            </Button>
            </Tooltip>
          </span>
        </div>
      </div>
    </>
  );
}

export default InitialState;
